import React, { Component } from 'react';
import PropTypes from 'prop-types';
import svgSprite from '../styles/img/sprite.svg';

class ChatInput extends Component {
  constructor(props) {
    super(props);
    this.messageInput = React.createRef();
    this.submitButton = React.createRef();
    this.loaderSubmit = React.createRef();
    this.msgForm = React.createRef();
  }

  componentDidMount() {
    this.focusMessageInput();
  }

  onOfButton = (val) => {
    if (this.submitButton.current) {
      this.submitButton.current.disabled = val;
    }
    if (this.messageInput.current) {
      this.messageInput.current.disabled = val;
    }
    if (this.loaderSubmit.current) {
      this.loaderSubmit.current.style.display = val ? 'block' : 'none';
    }
  }

  handleChange = (e) => {
    const { onInputMessage } = this.props;
    const { value } = e.target;
    const newLineLength = value.split('\n').length;
    if (newLineLength > 1) {
      this.submitButton.current.click();
      this.messageInput.current.value = '';
    }
    onInputMessage(e.target.value);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSendMessage, message } = this.props;
    this.onOfButton(true);
    onSendMessage(message);
  }

  focusMessageInput() {
    this.messageInput.current.focus();
    setTimeout(() => {
      this.onOfButton(false);
    }, 1000);
  }


  render() {
    const { message } = this.props;
    return (
      <div className="cta">
        <form onSubmit={this.handleSubmit} className="chat-input" autoComplete="off">
          <div className="autocomplete">
            <textarea
              name="text"
              // type="text"
              ref={this.messageInput}
              className="chat-input__input2"
              placeholder="Write messages"
              value={message}
              onChange={this.handleChange}
              rows={1}
              // onKeyDown={this.onEnterMessage}
              // onKeyPress={this.onEnterMessage}
            />
            {/* <input
              type="text"
              ref={this.messageInput}
              className="chat-input__input"
              placeholder="Write messages"
              value={message}
              onChange={this.handleChange}
            /> */}
          </div>
          <button type="submit" className="chat-input__button" ref={this.submitButton}>
            <svg className="chat-input__icon">
              <use xlinkHref={`${svgSprite}#icon-send-1`} />
            </svg>
          </button>
          <div ref={this.loaderSubmit} className="loading" style={{ marginLeft: '1rem', display: 'none' }} />
        </form>
      </div>
    );
  }
}

ChatInput.defaultProps = {
  message: '',
};

ChatInput.propTypes = {
  onSendMessage: PropTypes.func.isRequired,
  onInputMessage: PropTypes.func.isRequired,
  message: PropTypes.string,
};
export default ChatInput;
